import React, { useState } from "react";
import { StyledHome, TabStrip, TabButton } from "./styles";
import FeedOwnerSimple from "./FeedOwnerSimple";
import FeedOwnerDetailed from "./FeedOwnerDetailed";
import VrReportsOngoing from "./VrReportsOngoing";

type TabId = "simple" | "detailed" | "vr";

const TABS: { id: TabId; label: string }[] = [
  { id: "simple", label: "Feed Owner (Simple)" },
  { id: "detailed", label: "Feed Owner (Detailed)" },
  { id: "vr", label: "VR Reports Ongoing" }
];

export default function Analytics() {
  const [active, setActive] = useState<TabId>("simple");
  return (
    <StyledHome>
      <TabStrip>
        {TABS.map(t => (
          <TabButton key={t.id} active={active === t.id} onClick={() => setActive(t.id)}>
            {t.label}
          </TabButton>
        ))}
      </TabStrip>
      {active === "simple" && <FeedOwnerSimple />}
      {active === "detailed" && <FeedOwnerDetailed />}
      {active === "vr" && <VrReportsOngoing />}
    </StyledHome>
  );
}
